const types = {
  ALL_HORARIOS_VANS: "@horarioVans/ALL",
  UPDATE_HORARIO_VANS: "@horarioVans/UPDATE",
  FILTER_HORARIO_VANS: "@horarioVans/FILTER",
  ADD_HORARIO_VANS: "@horarioVans/ADD",
  RESET_HORARIO_VANS: "@horarioVans/RESET",
  ALL_SERVICES_VANS: "@horarioVans/ALL_SERVICES",
  REMOVE_HORARIO_VANS: "@horarioVan/REMOVE",
};

export default types;
